
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.75 12.74V8.75a3.51 3.51 0 00-3.5-3.5H8.75a3.499 3.499 0 00-3.5 3.5v24.5c0 1.925 1.558 3.5 3.5 3.5h24.5a3.51 3.51 0 003.5-3.5v-3.99c1.032-.613 1.75-1.715 1.75-3.01v-10.5c0-1.295-.718-2.398-1.75-3.01zM35 15.75v10.5H22.75v-10.5H35zM8.75 33.25V8.75h24.5v3.5h-10.5a3.51 3.51 0 00-3.5 3.5v10.5a3.51 3.51 0 003.5 3.5h10.5v3.5H8.75z"}}),_c('path',{attrs:{"d":"M28 23.625a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25z"}})])
          )
        }
      }
    